import { Navigate } from "react-router";
import { usePayComponentImportRedesignEnabled } from "../hooks/usePayComponentImportRedesignEnabled";
import { PAY_COMPONENT_IMPORT_BASE_PATH } from "../config";
import { UploadAndMapScreen } from "../redesign/UploadAndMapScreen";
import { ImportResultsScreen } from "../screens/ImportResultsScreen";
import { MapColumnsScreen } from "../screens/MapColumnsScreen";
import { ReviewScreen } from "../screens/ReviewScreen";
import { UploadPreviewScreen } from "../screens/UploadPreviewScreen";
import { ValidationErrorsScreen } from "../screens/ValidationErrorsScreen";

export function UploadExperienceRoute() {
  const redesignEnabled = usePayComponentImportRedesignEnabled();
  return redesignEnabled ? <UploadAndMapScreen /> : <UploadPreviewScreen />;
}

export function MapColumnsExperienceRoute() {
  const redesignEnabled = usePayComponentImportRedesignEnabled();
  if (redesignEnabled) {
    return <Navigate to={PAY_COMPONENT_IMPORT_BASE_PATH} replace />;
  }
  return <MapColumnsScreen />;
}

export function ReviewExperienceRoute() {
  const redesignEnabled = usePayComponentImportRedesignEnabled();
  return <ReviewScreen redesignEnabled={redesignEnabled} />;
}

export function ErrorsExperienceRoute() {
  const redesignEnabled = usePayComponentImportRedesignEnabled();
  return <ValidationErrorsScreen redesignEnabled={redesignEnabled} />;
}

export function ResultsExperienceRoute() {
  return <ImportResultsScreen />;
}
